
// form a brands slider with slick

$(document).ready(function(){
    function initializeSlick() {
        $('.brands-responsive').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            speed: 300,
            prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
            nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
            infinite: true,
            autoplaySpeed: 5000,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                }
            ]
        });
    }

    function destroySlick() {
        if ($('.brands-responsive').hasClass('slick-initialized')) {
            $('.brands-responsive').slick('unslick');
        }
    }

    var slideCount = $('.brands-responsive li').length;
    function checkWindowSize() {
        var windowWidth = $(window).width();
        if (windowWidth > 991) {
            if (slideCount > 5) {
                initializeSlick();
            } else {
                destroySlick();
            }
        } else {
            initializeSlick();
        }
    }
    checkWindowSize();
  
    $(window).resize(function() {
        checkWindowSize();
    });
});


$('.brands-responsive1').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 3000,
    slidesToShow: 6,
    slidesToScroll: 2,
 	arrows: true,
    prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
    nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }    
    ]
  });





// testimonal slider

// form a brands slider with slick
$('.testimonal-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 2,
 	arrows: true,
    prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
    nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


// product banner slider
// form a brands slider with slick
$('.whatwe-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
 	arrows: true,
    prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
    nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: true,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

// our story js 
$('.our-story').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
 	arrows: true,
    prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
    nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

// read more readlles js

 jQuery(document).ready(function() {	
	jQuery('.description').readmore({
		speed: 300,
		collapsedHeight: 60,
		moreLink: '<a style="color: #000; text-decoration: none;  font-weight: 700;" href="#">Read more</a>',
		lessLink: '<a style="color: #000; text-decoration: none;  font-weight: 700;" href="#">Read less</a>',
		heightMargin: 16
	});
	
});
$(document).ready(function(){
  $(".custom_collection_title .rich-text").click(function(){
    $(".custom_collection_desc .metafield-rich_text_field").slideToggle("slow");
  });
});
